// Mappings which specify how the same band is referred to as in the distinct datasets
export const DATASETS_BANDS = [
  {USNO: 'blue1', PanSTARR: 'g'},
  {USNO: 'red1', PanSTARR: 'r'},
  {USNO: 'blue2', PanSTARR: 'i'},
  {USNO: 'red2', PanSTARR: 'z'},
  {USNO: 'ir', PanSTARR: 'y'}
]
